import jwt from 'jsonwebtoken'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import queryString from 'query-string'
import { bindPromiseCreators } from '../../utils/routines'
import { withJob } from 'react-jobs'
import { withApplicationsReducer } from '../Applications/reducer'
import { withFetchAllApplysSaga } from '../Applications/saga'
import { createFetchAllApplysPromise } from '../Applications/routines'
import { selectLastUserApplication } from '../Applications/selectors'
import { withSaga } from './saga'
import { withReducer } from './reducer'
import { createVerificationPromise } from './routines'
import AccountVerificationRequesting from './AccountVerificationRequesting'
import AccountVerificationFailure from './AccountVerificationFailure'

// react-redux connect
const mapStateToProps = createStructuredSelector({
  lastApply: selectLastUserApplication,
})
const mapDispatchToProps = bindPromiseCreators({
  verify: createVerificationPromise,
  fetchApplys: createFetchAllApplysPromise
})
const connector = connect(mapStateToProps, mapDispatchToProps)

// job
async function work(props) {
  const { token } = queryString.parse(props.location.search)
  const verified = await props.verify(token)
  const { id } = jwt.decode(verified)
  await props.fetchApplys(id)
}

const job = withJob({
  work,
  LoadingComponent: AccountVerificationRequesting,
  ErrorComponent: AccountVerificationFailure
})

const enhancer = compose(
  withApplicationsReducer,
  withFetchAllApplysSaga,
  withReducer,
  withSaga,
  connector,
  job
)

export default enhancer
